import { useState } from "react"

const usePage = () => {
  const [page, setPage] = useState(1)
  const [byPage, setByPage] = useState(10)
  const [totalItems, setTotalItems] = useState(0)

  const resetPage = () => {
      setPage(1)
  }

  return {
      page,
      byPage,
      totalItems,
      resetPage,
      setPage,
      setByPage,
      setTotalItems
  }
}

export default usePage